import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fadeInUp, staggerContainer, WHATSAPP_URL } from "@/lib/constants";
import { useScrollToSection } from "@/hooks/useScrollToSection";

export const CTAFinalSection = () => {
  const handleContactClick = useScrollToSection("contacto");

  return (
    <section className="relative section-padding overflow-hidden" data-testid="cta-final-section">
      <div className="spotlight-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" />

      <div className="max-w-3xl mx-auto relative z-10">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={staggerContainer}
        >
          <motion.div variants={fadeInUp} className="text-center">
            <h2 className="text-3xl sm:text-4xl font-bold mb-6 leading-tight">
              Pongamos a tu stack de datos{" "}
              <span className="text-gradient">a trabajar de verdad</span>
            </h2>

            <p className="text-slate-400 text-base md:text-lg leading-relaxed mb-4 max-w-2xl mx-auto">
              Una sesión técnica de 30 minutos: te digo qué tienes, qué se puede integrar,
              qué KPIs miraría primero y qué resultados son razonables esperar en 60-90 días.
            </p>

            <p className="text-slate-300 text-base md:text-lg font-medium mb-8 max-w-2xl mx-auto">
              Sin propuestas plantilla. Hablamos sobre tus datos reales.
            </p>

            <p className="text-slate-500 text-sm mb-8 max-w-xl mx-auto font-mono">
              Diagnóstico gratuito · Respuesta en menos de 24 h · Murcia y resto de España
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                asChild
                className="btn-glow bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-6 text-base rounded-full"
                data-testid="cta-final-primary-btn"
              >
                <Link to="/contacto" onClick={handleContactClick}>
                  Solicitar diagnóstico técnico
                  <ArrowRight className="ml-2 h-5 w-5" />
                </Link>
              </Button>
              <Button
                asChild
                className="bg-green-600 hover:bg-green-700 text-white px-8 py-6 text-base rounded-full transition-all hover:scale-105 hover:shadow-lg hover:shadow-green-600/30"
                data-testid="cta-final-whatsapp-btn"
              >
                <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                  </svg>
                  Escríbeme por WhatsApp
                </a>
              </Button>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
